import React from 'react';

import { X } from 'lucide-react';

import { WorkflowInputPanel } from '@/components/workflows/WorkflowInputPanel';

interface Props {
  onClose: () => void;
  onCreated: (projectId: string) => void;
}

export function WorkflowInputModal({ onClose, onCreated }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-3xl rounded-2xl bg-white shadow-2xl dark:bg-neutral-950">
        <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4 dark:border-neutral-800">
          <div>
            <div className="text-base font-semibold text-slate-900 dark:text-white">
              Tell us about your workflow
            </div>
            <div className="mt-1 text-xs text-slate-500 dark:text-neutral-400">
              Type, talk, or drop files. We’ll draw a sandbox graph you can edit.
            </div>
          </div>
          <button
            className="rounded-lg p-2 hover:bg-slate-100 dark:hover:bg-neutral-900"
            onClick={onClose}
            aria-label="Close"
          >
            <X className="h-5 w-5 text-slate-600 dark:text-neutral-300" />
          </button>
        </div>

        <div className="p-5">
          <WorkflowInputPanel onCreated={onCreated} onCancel={onClose} />
        </div>
      </div>
    </div>
  );
}

